import Joi from 'joi';

export const CommitteeSchema = Joi.object({
  title: Joi.string().required(),
  pined: Joi.string().required(),
  file: Joi.string().required(),
});
